export default {"src":"/_next/static/media/how-3.a9dc6a47.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};